<template>
  <div class="template-name-holder">
    <close-button class="close" @click="close()"></close-button>

    <form
      name="templateForm"
      method="post"
      action="/saveTemplate"
      @submit.prevent="save()"
    >
      <input
        type="text"
        name="template-name"
        placeholder="Naam voor deze template"
        v-model="templateForm.tplName"
        ref="input"
        required
      />
      <div ng-hide="multiFormats" class="myclearfix text-holder">
        <select-box
          class="select-holder"
          id="set-def"
          @action="setDefault"
          :selected="isDefault"
          :color="rootStore.interaction.subColor"
        ></select-box>
        <label for="set-def" class="pointer">Default voor {{ format }} </label>
      </div>
      <div class="btn-holder">
        <button
          type="submit"
          class="pill-button"
          :disabled="templateForm.tplName.length < 2"
        >
          Bewaar
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { savePrintTemplate } from '../../PrintOrderApi'
import { useFileListStore } from '@/stores/FileList.store'
import { mapStores } from 'pinia'

export default {
  data() {
    return {
      isDefault: false,
      templateForm: {
        tplName: ''
      },
      format: this.files[0].format
    }
  },
  props: ['files'],
  mounted() {
    this.$refs.input.focus()
  },
  computed: {
    ...mapStores(useFileListStore)
  },
  methods: {
    close() {
      this.$emit('close')
    },
    save() {
      const newTemplate = {}
      newTemplate['0'] = {
        name: this.templateForm.tplName,
        default: this.isDefault,

        format: this.files[0].format,
        colorMode: this.files[0].colorMode,
        material: this.files[0].material,
        side: this.files[0].side,
        treatment: this.files[0].treatment,
        productSpecs: this.files[0].productSpecs
      }

      savePrintTemplate(newTemplate).then((resp) => {
        this.$emit('saved', resp)
        this.$emit('close')
      })

      let fileNames = []
      this.files.forEach((file) => {
        fileNames.push(file.fileName)
      })

      this.fileListStore.addProduct(fileNames, newTemplate['0'].productSpecs)

      this.fileListStore.updateFileSpec(
        fileNames,
        'template',
        newTemplate['0'].name
      )

      this.fileListStore.updateFileSpec(
        fileNames,
        'colorMode',
        newTemplate['0'].colorMode
      )

      this.fileListStore.updateFileSpec(
        fileNames,
        'format',
        newTemplate['0'].format
      )

      this.fileListStore.updateFileSpec(
        fileNames,
        'material',
        newTemplate['0'].material
      )

      this.fileListStore.updateFileSpec(
        fileNames,
        'side',
        newTemplate['0'].side
      )

      this.fileListStore.updateFileSpec(
        fileNames,
        'treatment',
        newTemplate['0'].treatment
      )
    },
    setDefault() {
      this.isDefault = !this.isDefault
    }
  }
  /* validations: {
    templateForm: {
      tplName: {
        minLength: minLength(2),
        required
      }
    }
  } */
}
</script>

<style lang="scss" scoped>
.template-name-holder {
  box-shadow: rgba(0, 0, 0, 0.25) 0px 0px 20px;
  border-radius: 5px;
  background-color: white;
  text-align: left;
  padding: 20px;
  width: 215px;

  &:before {
    transform: rotate(45deg);
    box-shadow: rgba(10, 10, 10, 0.1) -1px -2px 3px;
    background: white;
    content: '';
    position: absolute;
    top: -8px;
    right: 10px;
    width: 16px;
    height: 16px;
  }
}
.close {
  position: absolute;
  top: 15px;
  right: 15px;
}

.select {
  float: left;
}

input {
  margin: 14px 0px 17px;
  width: 100%;
}

label {
  font-weight: 300;
  margin-top: -3px;
  width: 153px;
  margin-right: 0;
}

.select-box {
  float: left;
}
.text-holder {
  padding: 5px 0;
}

.btn-holder {
  text-align: right;
  padding-top: 10px;
}
</style>
